import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-3" }

import { Checkbox, InputRow, Select } from '@/components/ui/form';
    import { computed } from 'vue';
    import { Input } from '@/components/ui/input';
    import { OnboardingStep } from '@/types';
    import { Textarea } from '@/components/ui/textarea';
    import { useI18n } from 'vue-i18n';
    import { useOnboardingStepData } from '@/composables/useOnboardingStepData';
    import type { SelectOption } from '@/types';
    import type { Table } from '@tanstack/vue-table';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingStepForm',
  props: {
    form: {},
    table: {},
    disableServiceChange: { type: Boolean }
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();

    const { onboardingStepOptions } = useOnboardingStepData();

    const statusOptions = computed<SelectOption[]>(() => {
        if (!onboardingStepOptions.value) return [];

        const existingServices = new Set(
            props.table.getRowModel().rows.map((row) => row.original.service),
        );

        return onboardingStepOptions.value
            .filter((onboardingStep: OnboardingStep) => {
                return (
                    onboardingStep.service === 'other' ||
                    !existingServices.has(onboardingStep.service) ||
                    onboardingStep.service === props.form.service
                );
            })
            .map((onboardingStep: OnboardingStep) => ({
                value: onboardingStep.service,
                label: t(`onboarding.services.${onboardingStep.service}`),
            }));
    });

    const isDefault = computed(() => {
        return !!props.form.service && props.form.service !== 'other';
    });

    const isOther = computed(() => {
        return props.form.service === 'other';
    });

    const descriptionPlaceholder = computed(() => {
        if (isDefault.value) {
            return t(`onboarding.steps.${props.form.service}.description`);
        }

        return t('onboarding.form.description_placeholder');
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "service",
      label: "onboarding.form.service"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Select), {
          modelValue: _ctx.form.service,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.service) = $event)),
          options: statusOptions.value,
          disabled: _ctx.disableServiceChange
        }, null, 8, ["modelValue", "options", "disabled"])
      ]),
      _: 1
    }, 8, ["form"]),
    (isOther.value)
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 0,
          form: _ctx.form,
          name: "other_title",
          label: "onboarding.form.title"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Input), {
              modelValue: _ctx.form.other_title,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.other_title) = $event)),
              placeholder: _unref(t)('onboarding.steps.other.title')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "description",
      label: "onboarding.form.description"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Textarea), {
          id: "description",
          modelValue: _ctx.form.description,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.description) = $event)),
          placeholder: descriptionPlaceholder.value,
          disabled: isDefault.value
        }, null, 8, ["modelValue", "placeholder", "disabled"])
      ]),
      _: 1
    }, 8, ["form"]),
    (isOther.value)
      ? (_openBlock(), _createBlock(_unref(Checkbox), {
          key: 1,
          id: "allow_comments",
          modelValue: _ctx.form.allow_comments,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.allow_comments) = $event)),
          label: "onboarding.form.allow_comments"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (isOther.value)
      ? (_openBlock(), _createBlock(_unref(Checkbox), {
          key: 2,
          id: "allow_files",
          modelValue: _ctx.form.allow_files,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.allow_files) = $event)),
          label: "onboarding.form.allow_files"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})